module.exports = __webpack_public_path__ + "src/assets/img/modalhand.079078ff.png";